import React from 'react';
import '@ionic/core/css/core.css';
import '@ionic/core/css/ionic.bundle.css';
import { IonReactRouter } from '@ionic/react-router';
import { IonApp, IonSplitPane, IonPage, isPlatform } from '@ionic/react';
import store from "./store/store";
import { Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import AppStack from "./pages/AppStack";
import About from './pages/About';
import ContactUs from './pages/ContactUs';
import ProfileMenu from './components/ProfileMenu';


const App: React.FC = () => (
  <Provider store={store}>
    <div id="app">
      <IonApp>
        <IonReactRouter>
          <IonSplitPane contentId="main">
            <ProfileMenu />
            <IonPage id="main">
              <Switch>
                <Route path="/about" component={About} />
                <Route path="/contactus" component={ContactUs} />
                <Route path="/" component={AppStack} />
              </Switch>
            </IonPage>
          </IonSplitPane>
        </IonReactRouter>
      </IonApp>
    </div>
  </Provider>
);

export default App;